<template>
  <v-app-bar app flat v-bind="$attrs"
             class="white tw-border-b tw-border-solid tw-border-gray-200"
  >
    <default-header-logo class="tw-absolute tw-top-0 tw-left-0" />
    <v-spacer />
    <default-header-navigation v-if="$vuetify.breakpoint.mdAndUp" />
    <v-btn icon small @click="$emit('drawer')">
      <v-icon>
        mdi-dots-vertical
      </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import DefaultHeaderLogo from './DefaultHeaderLogo'
import DefaultHeaderNavigation from './DefaultHeaderNavigation'
export default {
  name: 'DefaultHeader',
  components: { DefaultHeaderNavigation, DefaultHeaderLogo }
}
</script>

<style scoped>

</style>
